export const AllBrandsProductListingConstants = {
    GET_ALL_BRANDS_PRODUCT_LISTING: 'GET_ALL_BRANDS_PRODUCT_LISTING',

    GET_ALL_BRANDS_PRODUCTS_REQUEST: 'GET_ALL_BRANDS_PRODUCTS_REQUEST',
    GET_ALL_BRANDS_PRODUCTS_SUCCESS: 'GET_ALL_BRANDS_PRODUCTS_SUCCESS',
    GET_ALL_BRANDS_PRODUCTS_FAILURE: 'GET_ALL_BRANDS_PRODUCTS_FAILURE'
};